<template>
<div class="in_clazz_panel after_border">
  <van-tag v-if="race.status === 'not_start'" size="medium" class="race-tag">未开始</van-tag>
  <van-tag v-else-if="race.status === 'ing'" size="medium" class="race-tag" type="primary">进行中</van-tag>
  <van-tag v-else-if="race.status === 'success'" size="medium" class="race-tag" type="success">已完成</van-tag>
  <van-tag v-else-if="race.status === 'fail'" size="medium" class="race-tag">未完成</van-tag>
  <img class="cover" v-lazy="race.cover_url">
  <div class="info">
    <div class="title">{{ race.name }}</div>
    <div class="process">赛事时间：{{ race.start_time }}～{{ race.end_time }}</div>
    <div class="process">赛事距离：{{ race.info.distance }}公里</div>
    <div class="process">报名时间：{{ race.add_time_format }}</div>
  </div>
</div>
</template>

<script>
import { Tag } from 'vant'

export default {
  name: 'InClazzPanel',
  components: {
    [Tag.name]: Tag
  },
  props: {
    race: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.in_clazz_panel {
  width: 750px;
  height: 180px;
  padding: 25px 0;
  display: flex;
  position: relative;
  .race-tag {
    position: absolute;
    left: 20px;
    // top: 30px;
    // opacity: 0.8;
  }
  .cover {
    width: 180px;
    height: 180px;
    margin-left: 20px;
    object-fit: cover;
  }
  .info {
    display: flex;
    flex-direction: column;
    height: 180px;
    margin-left: 20px;
    width: 500px;
    .title {
      font-size: 32px;
      font-weight: bold;
      color: #323233;
      height: 40px;
      margin-bottom: 20px;
    }
    .cycle, .process {
      font-size: 26px;
      color: #aaa;
      height: 40px;
      margin-top: 5px;
    }
    .cycle {
      margin-top: 20px;
    }
    .process {
      height: 33px;
    }
    .btn_daka_warp {
      display: flex;
      justify-content: flex-end;
    }
    .btn_daka {
      width: 100px;
      height: 45px;
      color: #fff;
      background-color: #f5222d;
      font-size: 24px;
      margin-top: 8px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
